













import { defineComponent } from "@vue/composition-api";
import { Message } from "@scrile/api-provider/dist/projects/scrileConnect/MessagesProvider";
import BaseAvatar from "@/components/BaseAvatar";

export default defineComponent({
  name: "MessageJoin",
  components: { BaseAvatar },
  props: {
    message: { type: Object as () => Message, required: true },
  },
});
